/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';

/**
 * 
 * @export
 * @interface UpdateProfileRequest
 */
export interface UpdateProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    cellPhone: string;
    /**
     * 
     * @type {Gender}
     * @memberof UpdateProfileRequest
     */
    gender?: Gender | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateProfileRequest
     */
    dateOfBirth?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    homePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    city?: string | null;
}



/**
 * Check if a given object implements the UpdateProfileRequest interface.
 */
export function instanceOfUpdateProfileRequest(value: object): value is UpdateProfileRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    return true;
}

export function UpdateProfileRequestFromJSON(json: any): UpdateProfileRequest {
    return UpdateProfileRequestFromJSONTyped(json, false);
}

export function UpdateProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'cellPhone': json['cellPhone'],
        'gender': json['gender'] == null ? undefined : GenderFromJSON(json['gender']),
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'address': json['address'] == null ? undefined : json['address'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
    };
}

export function UpdateProfileRequestToJSON(json: any): UpdateProfileRequest {
    return UpdateProfileRequestToJSONTyped(json, false);
}

export function UpdateProfileRequestToJSONTyped(value?: UpdateProfileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'cellPhone': value['cellPhone'],
        'gender': GenderToJSON(value['gender']),
        'dateOfBirth': value['dateOfBirth'],
        'homePhone': value['homePhone'],
        'address': value['address'],
        'zip': value['zip'],
        'state': value['state'],
        'city': value['city'],
    };
}

